const queryKeys = {
  billingV3Workflow: (tenantID: string) =>
    ["billingV3Workflow", tenantID] as const,
};

export default queryKeys;
